export default "__VITE_ASSET__D87FJa6A__"